<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <!-- Content -->

    <form name="operatorForm" [formGroup]="operatorForm" class="tax-type-form w-100-p p-20" fxLayout="column" fxFlex>
        <div class="labels" fxLayout="row" fxLayoutWrap fxShow.gt-sm *ngIf="action === recordAction.View">
            <div class="label" fxLayout="row" fxLayoutAlign="start center">
                <div class="label-color" [ngStyle]="{
                        'background-color': operatorModel.active
                            ? 'green'
                            : 'red'
                    }"></div>
                <div class="label-title">Activo</div>
            </div>
        </div>

        <mat-label>{{ "Nombre del Operador" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="name" formControlName="name" mat-maxlength="50" placeholder=""
                [readonly]="action === recordAction.View" required />
        </mat-form-field>

        <mat-label>{{ "MSISDN REGEX" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="msisdn_regex" formControlName="msisdn_regex" mat-maxlength="100" placeholder=""
                [readonly]="action === recordAction.View" required />
        </mat-form-field>

        <mat-label>{{ "MSISDN LENGTH" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="msisdn_length" type="number" formControlName="msisdn_length" mat-maxlength="10"
                placeholder="" [readonly]="action === recordAction.View" required />
        </mat-form-field>

        <mat-label>{{ "Start Window" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput type="time" class="input-time" name="time" formControlName="start_window" mat-maxlength="50"
                placeholder="" [readonly]="action === recordAction.View" />
        </mat-form-field>

        <mat-label>{{ "End Window" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput type="time" class="input-time" name="time" formControlName="end_window" mat-maxlength="50"
                placeholder="" [readonly]="action === recordAction.View" />
        </mat-form-field>
        <mat-label>{{ "País" | translate }}</mat-label>
        <mat-form-field appearance="outline">
            <mat-select placeholder="" formControlName="id_country" required>
                <mat-option>-- {{ "Seleccionar" | translate }} --</mat-option>
                <mat-option *ngFor="let country of countries" [value]="country.id">
                    {{ country.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-label>{{ "Protocolo" | translate }}</mat-label>
        <mat-form-field appearance="outline">
            <mat-select placeholder="" formControlName="protocolId" required>
                <mat-option>-- {{ "Seleccionar" | translate }} --</mat-option>
                <mat-option *ngFor="let protocol of protocols" [value]="protocol.id">
                    {{ protocol.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="center">
            <button *ngIf="action !== recordAction.Update" mat-raised-button (click)="performAction()"
                class="save-button" [disabled]="operatorForm.invalid" aria-label="GUARDAR">
                <span class="material-icons-outlined mr-16"> save </span>
                <span>{{ "Guardar" | translate }}</span>
            </button>

            <button *ngIf="action === recordAction.Update" mat-raised-button (click)="performAction()"
                class="save-button" [disabled]="operatorForm.invalid" aria-label="GUARDAR">
                <span class="material-icons-outlined mr-16"> save </span>
                <span>{{ "Guardar" | translate }}</span>
            </button>
        </div>
    </form>
    <!-- Content -->

    <!-- Buttons -->

    <!-- Buttons -->
</wtf-dialogcontent>